import { useEffect } from 'react';

/**
 * Bloquea el scroll del documento mientras `locked` sea true (drawer movil).
 * Compensa el ancho de la barra de scroll para que la pagina no "salte" —
 * ese salto es exactamente lo que la auditoria responsive marca como defecto.
 */
export function useScrollLock(locked: boolean): void {
  useEffect(() => {
    if (!locked) return;
    const { body, documentElement } = document;
    const gap = window.innerWidth - documentElement.clientWidth;
    const previousPadding = body.style.paddingRight;

    body.dataset['scrollLocked'] = 'true';
    if (gap > 0) body.style.paddingRight = `${gap}px`;

    return () => {
      delete body.dataset['scrollLocked'];
      body.style.paddingRight = previousPadding;
    };
  }, [locked]);
}
